import { render, staticRenderFns } from "./Indonesia.vue?vue&type=template&id=5db2f8bf&scoped=true&"
import script from "./Indonesia.js?vue&type=script&lang=js&"
export * from "./Indonesia.js?vue&type=script&lang=js&"
import style0 from "./Indonesia.vue?vue&type=style&index=0&id=5db2f8bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2f8bf",
  null
  
)

export default component.exports